import { BorderedSection } from '../../../../components';
import FinancialData from '../../../../components/common/FinancialData';
import TableRow from './TableRow';

type Strategy = {
  __typename: 'Strategy';
  externalMitigation: number;
  finishedGoodsInventory: number;
  grossRevenueExposure: number;
  internalMitigation: number;
  lengthOfDisruption: number;
  mitigation: number;
  netRevenueExposure: number;
  percentageBusinessSupported: number;
  revenueSupportedAnnually: number;
  strategyAge: number;
  summary: string;
  uuid: string;
  lastUpdate: string;
  bcpStatus: 'Finalized' | 'Draft' | 'In Progress';
  isDefault?: boolean;
  onSitesMitigation?: number | null;
  required?: boolean;
  finalizedAt?: string | null;
};

const ExposureSummaryTable = ({ data }: { data: Strategy }) => {
  const IS_LOCATION_STRATEGY = data && !('isDefault' in data);
  return (
    <BorderedSection title="Exposure Summary" noPadding>
      <section className="flex flex-col justify-between">
        <div className="w-full pt-3 pb-3 flex flex-col gap-3 h-full">
          <TableRow
            label="Revenue Supported Annually"
            value={data?.revenueSupportedAnnually || 0}
            type="money"
          />
          <TableRow
            label={
              IS_LOCATION_STRATEGY
                ? '% of Company Supported'
                : '% of Location Supported'
            }
            value={data?.percentageBusinessSupported || 0}
            type="percentage"
          />
          <TableRow
            label="Strategy Downtime"
            value={data?.lengthOfDisruption || 0}
            type="time"
          />
          <TableRow
            label="Total Revenue Exposure"
            value={data?.grossRevenueExposure || 0}
            type="money"
            bold
          />
          <section className="pr-5 pl-5 ">
            <hr />
          </section>
          <TableRow
            label="Finished Goods Inventory"
            value={data?.finishedGoodsInventory || 0}
            type="money"
          />
          <TableRow
            label="Onsite Mitigation"
            value={data?.onSitesMitigation || 0}
            type="money"
          />
          <TableRow
            label="Internal Mitigation"
            value={data?.internalMitigation || 0}
            type="money"
          />
          <TableRow
            label="External Mitigation"
            value={data?.externalMitigation || 0}
            type="money"
          />
          <TableRow
            label="Total Mitigation"
            value={data?.mitigation || 0}
            type="money"
            bold
          />
        </div>
        <div className="bg-silver border-t lg:border-b border-borders flex items-center justify-between p-4">
          <div className="text-primary-100 font-medium">
            Residual Revenue Exposure
          </div>
          <label className=" font-bold mr-4">
            {<FinancialData text={data?.netRevenueExposure || 0} />}
          </label>
        </div>
      </section>
    </BorderedSection>
  );
};

export default ExposureSummaryTable;
